import { ConfirmReservationConsultationData } from '../types'

class ConfirmReservationConsultationMapper {
  private static buildPaymentObject(data: ConfirmReservationConsultationData) {
    return {
      idTransacao: data?.payment?.transactionId,
      enderecoCobranca: {
        bairro: data?.payment?.billingAddress?.neighborhood,
        cep: data?.payment?.billingAddress?.cep,
        cidade: data?.payment?.billingAddress?.city,
        complemento: data?.payment?.billingAddress?.complement,
        logradouro: data?.payment?.billingAddress?.streetName,
        numero: data?.payment?.billingAddress?.number,
        pais: data?.payment?.billingAddress?.country,
        uf: data?.payment?.billingAddress?.state,
      },
      idCartao: data?.payment?.cardId,
      metodo: data?.payment?.method,
      sintomasEvidentes:
        data?.payment?.evidentSymptoms || data?.payment?.symptoms,
      tipoProfissional: data?.professional?.type,
      merchantOrderId: data?.payment?.merchantOrderId,
    }
  }

  static toDomain(data: ConfirmReservationConsultationData) {
    return {
      atendimento: {
        idTriagem: data?.screening?.id,
        dataHoraAgendamento: data?.appointment?.date,
        idProfissional: data?.professional?.id,
        cupomDesconto: data?.payment?.discountCoupon,
        cartaoConvenio: {
          id: data?.payment?.healthInsuranceCardId ?? null,
        },
        aps: false,
        pagamento: this.buildPaymentObject(data),
        loginMetricas: 'WEB',
        origemAtendimentoMetricas: 'AGENDADO_WEB',
      },
      contato: {
        email: data?.user?.email,
        celular: data?.user?.phone,
      },
    }
  }
}

export default ConfirmReservationConsultationMapper
